angular.module('impactx.logouttimer').service('LogoutTimerService', ['$timeout',
    '$controller',
    '$mdDialog',
    'cookieService',
    LogoutTimerService]);

function LogoutTimerService($timeout, $controller, $mdDialog, cookieService) {
    var self = this;
    var CONST_EXPIRY_DATE_COOKIE = "expiryDateLogout";
    var startSecondsUntilLogout = {};
    var logoutDialogIsShown = {value: false};
    var expiryDate;
    var currentTimeOut;
    this.timeUntilLogoutFormatted = {};

    var timeOutTick = function (dataGen) {
        var secondsToTimeOut = self.calcSecondsToTimeOut(expiryDate);
        if (secondsToTimeOut < 0)
        {
            logout();
        }
        else {
            if (secondsToTimeOut < 60 && !logoutDialogIsShown.value) {
                logoutDialogIsShown.value = true;
                $mdDialog.show({
                    controller: "LogoutTimerDialogCtrl",
                    controllerAs: 'logoutTimerDialogCtrl',
                    parent: angular.element(document.body),
                    templateUrl: 'shared/logouttimer/templates/timer.dialog.tmpl.html',
                    clickOutsideToClose: false
                }).then(function() {
                    // prevent ping to backend when dialog is automatically closed
                    // (e.g. after timer runs out or is reset while the dialog is open)
                    if (logoutDialogIsShown.value) {
                        dataGen.get({}, {}, '/ping').then(function () {
                            logoutDialogIsShown.value = false;
                        }, logout);
                    }
                });
            }
            else if (secondsToTimeOut >= 60 && logoutDialogIsShown.value)
            {
                logoutDialogIsShown.value = false;
                $mdDialog.hide();
            }
            self.timeUntilLogoutFormatted.value = secondsToTimeOut;
            currentTimeOut = $timeout(timeOutTick, 1000, true, dataGen);
        }
    };

    function logout () {
        logoutDialogIsShown.value = false;
        $mdDialog.hide();
        var ctrlLogout = $controller('LogoutCtrl', {
            $scope: {}
        });
        ctrlLogout.logout();
        ctrlLogout.redirectToLogin();
    }

    this.clearLogoutTimer = function() {
        cookieService.removeCookie(CONST_EXPIRY_DATE_COOKIE);
        startSecondsUntilLogout.value = undefined;
        if (currentTimeOut)
        {
            $timeout.cancel(currentTimeOut);
        }
    };

    var resetTimeout = function (dataGen) {
        if (currentTimeOut)
        {
            $timeout.cancel(currentTimeOut);
        }
        expiryDate = self.calcExpiryDate(startSecondsUntilLogout.value);
        currentTimeOut = $timeout(timeOutTick, 1000, true, dataGen);
    };

    this.checkNewData = function(dataGen, data)
    {
        if (data.data.tokenValidSeconds && !startSecondsUntilLogout.value)
        {
            expiryDate = self.calcExpiryDate(data.data.tokenValidSeconds);
            startSecondsUntilLogout.value = self.calcSecondsToTimeOut(expiryDate);
            cookieService.setCookie(CONST_EXPIRY_DATE_COOKIE, expiryDate);
        }
        else
        {
            if (!data.data.noTokenValidSeconds && !startSecondsUntilLogout.value)
            {
                expiryDate = cookieService.getCookieValue(CONST_EXPIRY_DATE_COOKIE);
                startSecondsUntilLogout.value = self.calcSecondsToTimeOut(expiryDate);
            }
            else if (data.data.noTokenValidSeconds)
            {
                cookieService.removeCookie(CONST_EXPIRY_DATE_COOKIE);
            }

        }
        if (startSecondsUntilLogout.value)
        {
            resetTimeout(dataGen);
        }
        data.data.tokenValidSeconds = undefined;
    };

    this.calcSecondsToTimeOut = function (expiryDate)
    {
        return Math.round((new Date(expiryDate) - new Date()) / 1000);
    };

    this.calcExpiryDate = function (secondsToTimeOut)
    {
        var date = new Date();
        date.setSeconds(date.getSeconds() + secondsToTimeOut);
        return date;
    };
}
